import styled, { css } from 'styled-components';

import { layout } from '../../../package.json';

interface ContainerMobileProps {
  mobile?: boolean;
}

export const Root = styled.section`
  padding-top: 10px;
  padding-bottom: 20px;
  min-height: 75vh;
  width: 100%;
`
export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
`;

export const ContainerLoading = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    width: 98% !important;
    display: block !important;
  }
`;

export const ContainerProducts = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  width: 100%;
  margin-bottom: 30px;

  color: #646464;
`;

export const ContainerProductsResult = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin: 0 auto;
`;

export const ContainerProductsResultRow = styled.div<ContainerMobileProps>`
  display: grid;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;

  ${props =>
    props.mobile &&
    css`
      flex-direction: column;
    `};

  @media (max-width: ${layout.tablet}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${layout.tablet}) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media (min-width: ${layout.desktop}) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }

  @media (min-width: ${layout.desktop_wide}) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  }                         
`;

export const MessageProductNotFound = styled.span`
  width: 100%;
  font-size: 28px;
  color: var(--primary);
  text-align: center;
`;

export const ScrollSentinel = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 20px;
`;
